import {useMessage} from '@coolcolduk/ui-mui';
import {Message} from '@mui/icons-material';
import {Box, IconButton} from '@mui/material';
import {useEffect, useState} from 'react';
import {ContactCategory} from '../../__generated__/resolvers-types';
import useCreateContactMessage from '../../hook/useCreateContactMessage';
import ContactUsDialog, {ContactUsDialogProps} from './ContactUsDialog';

export interface ContactUsProps extends Pick<ContactUsDialogProps, 'user'> {}

export default function ContactUs({user}: ContactUsProps) {
  const [isOpen, setIsOpen] = useState(false);
  const {writeContactMessageToFirestore, success, error} = useCreateContactMessage();
  const {showMessage} = useMessage();

  useEffect(() => {
    if (success) {
      showMessage('Message sent successfully', undefined, 'success');
    }
    if (error) {
      showMessage('Failed to send message', undefined, 'error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, error]);

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1000,
          '> button': {borderRadius: '10%'},
        }}
      >
        <IconButton color="primary" onClick={() => setIsOpen(true)} size="large" sx={{p: 1}}>
          <Message sx={{width: 40, height: 40}} />
        </IconButton>
      </Box>

      <ContactUsDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        categories={Object.values(ContactCategory)}
        user={user}
        handleSend={writeContactMessageToFirestore}
      />
    </>
  );
}
